import React from 'react';
import { incidentApi } from '../services/api';
import { RegisterItemDetail } from './RegisterItemDetail';

export const IncidentDetail: React.FC = () => {
  return (
    <RegisterItemDetail
      kind="incident"
      idParam="id"
      title="Incident"
      iconClass="ri-alarm-warning-line"
      api={incidentApi}
    />
  );
};
